import React from 'react'
import { Typography, Box, Chip, IconButton } from '@material-ui/core'
import { Trash2 as Trash2Icon } from 'react-feather'

import { Card } from 'components'

import helpers from 'helpers'

import useStyles from './styles'
import constants from 'constants/index'

const CardType = ({ children, planAction, setPlanActionId, isEdit }) => {
  const classes = useStyles()

  const handleOpenDialog = () => setPlanActionId(planAction?.id)

  return (
    <Card
      title={
        <Box display="flex" flexDirection="row" alignItems="center">
          <Box mr={2}>
            <Typography variant="h5">
              #{planAction?.id} Plano de ação
            </Typography>
          </Box>
          <Chip
            size="small"
            className={helpers.questionControls.statusChipColor(
              planAction?.status,
              classes,
            )}
            label={helpers.questionControls.status(planAction?.status)}
          />
        </Box>
      }
      {...(isEdit && {
        actionButton: (
          <Box pr={1}>
            <IconButton size="small" onClick={handleOpenDialog}>
              <Trash2Icon size={20} />
            </IconButton>
          </Box>
        ),
      })}
      dropdown={
        planAction?.status === constants.questionControl.CONCLUSION_PLAN_STATUS
      }
    >
      {children}
    </Card>
  )
}
export default CardType
